import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import { BodyBuilder } from "../../exports/Images";
import SubscriptionEditForm from "./SubscriptionEditForm";
import { updateSubscription } from "../../redux/reducers/postApiSlice";
import { formattedAmount } from "../../components/common-data/Converts";
import TableSkeleton from "../../components/common-components/TableSkeleton";
import CommonTable from "../../components/common-components/common-tables/CommonTable";
import {
  CalendarIcon,
  CallIcon,
  ClockIconV3,
  DownloadIcon,
  EditIcon1,
  EmailIcon,
  LocationIcon1,
  PersonIcon,
} from "../../images/icons/icons";

const SubscriptionTable = ({
  allSubsTbData,
  decryptedText,
  callSubscription,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
}) => {
  const dispatch = useDispatch();
  const { allSubscriptionDataLoading } = useSelector((state) => state.api);
  const isAdmin = decryptedText?.account_type === "admin";
  // Subscription Edit/Actions visible to admin and gym account types
  const canEditSubscription =
    decryptedText?.account_type === "admin" ||
    decryptedText?.account_type === "gym";

  const [imageModal, setImageModal] = useState(false);
  const [viewImage, setViewImage] = useState("");
  const [editInfo, setEditInfo] = useState({});
  const [editModal, setEditModal] = useState(false);
  const [goalRemarksModal, setGoalRemarksModal] = useState(false);
  const [selectedGoalRemarks, setSelectedGoalRemarks] = useState("");

  const { start_date, expire_date, subscription_status, user_id, gym_id, uid } =
    editInfo || {};
  const dateRevFormat = (time) =>
    moment(time).tz("Asia/Kolkata").format("YYYY-MM-DD");
  const initialCreateSubsFormData = {
    enteredStartDate: "",
    enteredExpireDate: "",
    selectedStatus: "",
  };
  const [createSubsFormData, setCreateSubsFormData] = useState(
    initialCreateSubsFormData
  );
  const [createSubsFormErrors, setCreateSubsFormErrors] = useState({});
  const [isSubsFormTrue, setIsSubsFormTrue] = useState(false);

  const onClickSubmit = (e) => {
    e.preventDefault();

    setCreateSubsFormErrors(validateSubscriptionForm(createSubsFormData));
    setIsSubsFormTrue(true);
  };

  const handleEditSubscription = async (userData, TOKEN) => {
    setIsSubsFormTrue(false);
    try {
      const actionResult = dispatch(updateSubscription({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        callSubscription();
        setCreateSubsFormData(initialCreateSubsFormData);
        setCreateSubsFormErrors({});
        setEditModal(false);
        setEditInfo({});
      } else {
        const errorMessage = result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleEditSubscription ERROR => ", error);
    }
  };

  const validateSubscriptionForm = (createSubsFormData) => {
    let errors = {};

    if (!createSubsFormData.enteredStartDate) {
      errors.enteredStartDate = "Subscription start date required!";
    }

    if (!createSubsFormData.enteredExpireDate) {
      errors.enteredExpireDate = "Subscription expire date required!";
    }

    return errors;
  };

  const formatDate = (dateString) => {
    const formattedDate = moment(parseInt(dateString))
      .tz("Asia/Kolkata")
      .format("DD-MM-YYYY");
    return formattedDate;
  };

  useEffect(() => {
    if (start_date || expire_date || subscription_status) {
      setCreateSubsFormData({
        ...setCreateSubsFormData,
        enteredStartDate: start_date ? dateRevFormat(start_date) : "",
        enteredExpireDate: expire_date ? dateRevFormat(expire_date) : "",
        selectedStatus: subscription_status
          ? {
              label: subscription_status,
              value: subscription_status,
            }
          : "",
      });
    }
  }, [start_date, expire_date, subscription_status]);

  useEffect(() => {
    if (isSubsFormTrue && Object.keys(createSubsFormErrors)?.length === 0) {
      const userData = {
        subscription_id: uid || "",
        user_id: user_id || "",
        gym_id: gym_id || "",
        start_date: createSubsFormData.enteredStartDate || "",
        end_date: createSubsFormData.enteredExpireDate || "",
        status: createSubsFormData.selectedStatus?.value || "",
      };

      handleEditSubscription(userData, decryptedText?.token);
    } else {
      setIsSubsFormTrue(false);
    }
  }, [isSubsFormTrue]);

  // const subsTbColumn = [
  //   {
  //     dataField: "details_user",
  //     text: "Member Details",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="emeberDetailsRowContainer">
  //           <img
  //             src={row?.profile || BodyBuilder}
  //             alt={row?.user_name || "NA"}
  //             className="image"
  //             onClick={() => {
  //               setViewImage(row?.profile || BodyBuilder);
  //               setImageModal(true);
  //             }}
  //           />

  //           <div className="flexColumn">
  //             <span className="tb-data" style={{ textAlign: "start" }}>
  //               <small className="lowercase" style={{ color: "gray" }}>
  //                 {row?.uid || "-"}
  //               </small>
  //               <br />
  //               {row?.user_name || "NA"}
  //               <br />
  //               <small className="underline lowercase">
  //                 {row?.user_mobile || ""}
  //                 <br />
  //                 {row?.user_email || ""}
  //               </small>
  //               {row?.experience_level && (
  //                 <>
  //                   <br />
  //                   <small className="gray underline">
  //                     {row?.experience_level}
  //                   </small>
  //                 </>
  //               )}
  //             </span>
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "gym_name",
  //     text: "Gym Name",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data minWidth150" style={{ textAlign: "start" }}>
  //           <small>{row?.gym_name || "NA"}</small>
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "source_name",
  //     text: "Source Name",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data minWidth90">
  //           {row?.source_name?.replace(/_/g, " ") || "-"}
  //         </span>
  //       );
  //     },
  //   },
  //   // {
  //   //   dataField: "type",
  //   //   text: "Subs Type",
  //   //   formatter: (_, row) => {
  //   //     return (
  //   //       <span
  //   //         className="tb-data withPadding minWidth100"
  //   //         style={{
  //   //           background: row?.one_day_membership
  //   //             ? "#cd0909"
  //   //             : row?.type === "addon_pt"
  //   //             ? "#066CE3"
  //   //             : row?.type === "addon"
  //   //             ? "#5A56E4"
  //   //             : row?.type === "regular"
  //   //             ? "#00B295"
  //   //             : "#686D76",
  //   //           color: "#fff",
  //   //           borderRadius: "10px",
  //   //         }}
  //   //       >
  //   //         <small>
  //   //           {row?.one_day_membership
  //   //             ? "One Day"
  //   //             : row?.type === "addon_pt"
  //   //             ? "PT"
  //   //             : row?.type?.replace(/_/g, " ") || "NA"}
  //   //         </small>
  //   //       </span>
  //   //     );
  //   //   },
  //   // },
  //   {
  //     dataField: "plan_name",
  //     text: "Plan Name",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data minWidth150"
  //           // style={{
  //           //   background:
  //           //     row?.type === "addon_pt"
  //           //       ? "#066CE3"
  //           //       : row?.type === "addon"
  //           //       ? "#5A56E4"
  //           //       : row?.type === "regular"
  //           //       ? "#00B295"
  //           //       : "#686D76",
  //           //   color: "#fff",
  //           //   borderRadius: "10px",
  //           // }}
  //         >
  //           <small className="underline gray">
  //             {row?.one_day_membership
  //               ? "One Day"
  //               : row?.type === "addon_pt"
  //               ? "PT"
  //               : row?.type?.replace(/_/g, " ") || "NA"}
  //           </small>
  //           <br />
  //           <small>
  //             {row?.type === "regular"
  //               ? row?.plan_name
  //               : row?.addon_name || "NA"}
  //           </small>
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "price",
  //     text: "Price",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data">
  //           ₹{row?.price ? formattedAmount(row.price) : 0}
  //           <br />
  //           <small
  //             className="gray underline"
  //             style={{ textTransform: "initial" }}
  //           >
  //             {row?.trx_id === "cash"
  //               ? "Cash"
  //               : row?.trx_id === "import_member"
  //               ? row.trx_id?.replace(/_/g, " ")
  //               : `Online/${row?.trx_id}` || "NA"}
  //           </small>
  //           {row?.payment_location && (
  //             <>
  //               <br />
  //               <small className="underline">
  //                 (
  //                 {row.payment_location === "gym"
  //                   ? "Inside Gym"
  //                   : "Outside Gym"}
  //                 )
  //               </small>
  //             </>
  //           )}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "date_added",
  //     text: "Subs Start/Expire Date",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data minWidth100">
  //           <small className="gray underline">
  //             {row?.date_added ? formatDate(row.date_added) : "-"}
  //           </small>
  //           <br />
  //           {row?.start_date
  //             ? moment(row.start_date).tz("Asia/Kolkata").format("DD-MM-YYYY")
  //             : "-"}
  //           <br />/
  //           {row?.expire_date
  //             ? moment(row.expire_date).tz("Asia/Kolkata").format("DD-MM-YYYY")
  //             : "-"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "subscription_status",
  //     text: "Subs Status",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data withPadding borderRdius8 minWidth150"
  //           style={{
  //             background:
  //               row?.subscription_status === "active" ? "#379C00" : "#C90808",
  //             color: "#fff",
  //           }}
  //         >
  //           <small>{row?.subscription_status || "NA"}</small>
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "checkout_source",
  //     text: "Checkout Source",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data">
  //           {row?.checkout_source?.replace(/_/g, " ") || "-"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "gender",
  //     text: "Gender",
  //     formatter: (_, row) => {
  //       return (
  //         <span className="tb-data">
  //           {row?.gender === "male" ? "♂" : row?.gender === "female" ? "♀" : ""}
  //           <br />
  //           {row?.gender || "-"}
  //         </span>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "goal_remarks",
  //     text: "Goal Remarks",
  //     formatter: (_, row) => {
  //       return (
  //         <span
  //           className="tb-data "
  //           onClick={() => {
  //             if (row?.goal_remarks) {
  //               setSelectedGoalRemarks(row.goal_remarks);
  //               setGoalRemarksModal(true);
  //             }
  //           }}
  //         >
  //           {row?.goal_remarks ? (
  //             <>
  //               <small className="underline link">view</small>
  //             </>
  //           ) : (
  //             "NA"
  //           )}
  //         </span>
  //       );
  //     },
  //   },
  //   isSubAddEdit && {
  //     dataField: "action",
  //     text: "Action",
  //     formatter: (_, row) => (
  //       <div className="actionButtonContainer">
  //         <button
  //           className="actionBtn icon edit"
  //           onClick={() => {
  //             setEditInfo(row);
  //             setEditModal(true);
  //           }}
  //           style={{ border: "none", cursor: "pointer" }}
  //         >
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="16"
  //             height="16"
  //             fill="currentColor"
  //             className="bi bi-pencil-fill"
  //             viewBox="0 0 16 16"
  //           >
  //             <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
  //           </svg>
  //         </button>
  //       </div>
  //     ),
  //   },
  // ];

  const tbColumns = [
    {
      dataField: "user_name",
      text: "member info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>{" "}
              <span className="tb-data">{row?.user_name || "NA"}</span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CallIcon />
              </span>{" "}
              <span className="tb-data">{row?.user_mobile || "NA"}</span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <EmailIcon />
              </span>{" "}
              <span className="tb-data lowercase">
                {row?.user_email || "NA"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 25;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.one_day_membership
                ? "One Day"
                : row?.type === "addon_pt"
                ? "PT"
                : row?.type?.replace(/_/g, " ") || "NA"}
            </span>

            <span className="tb-data">
              {" "}
              {row?.type === "regular"
                ? row?.plan_name
                : row?.addon_name || "NA"}{" "}
              @₹{row?.price ? formattedAmount(row.price) : 0}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "subscription_status",
      text: "Subs Status",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data tb-badge ${
              row?.subscription_status === "active"
                ? "tb-badge-success"
                : "tb-badge-stuck"
            }`}
          >
            {row?.subscription_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "trx_id",
      text: "transaction ID",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <span className="tb-data">
              {row?.is_imported === 1
                ? "Import Member"
                : row?.trx_id === "cash"
                ? "Cash"
                : `Online/${row?.trx_id}` || "NA"}
            </span>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <LocationIcon1 />
              </span>{" "}
              <span className="tb-data">
                {row.payment_location === "gym" ? "Inside Gym" : "Outside Gym"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Add Date",
      formatter: (_, row) => {
        return (
          <div className="tb-flex">
            <span className="tb-data tb-info-icon">
              <ClockIconV3 />
            </span>{" "}
            <span className="tb-data">
              {row?.date_added ? formatDate(row.date_added) : "-"}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "duration",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.start_date
                  ? moment(row.start_date)
                      .tz("Asia/Kolkata")
                      .format("DD-MM-YYYY")
                  : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalendarIcon />
              </span>{" "}
              <span className="tb-data">
                {row?.expire_date
                  ? moment(row.expire_date)
                      .tz("Asia/Kolkata")
                      .format("DD-MM-YYYY")
                  : "-"}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "source_name",
      text: "Source Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.source_name?.replace(/_/g, " ") || "-"}
          </span>
        );
      },
    },
    {
      dataField: "checkout_source",
      text: "Checkout Source",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {" "}
            {row?.checkout_source?.replace(/_/g, " ") || "-"}
          </span>
        );
      },
    },
    {
      dataField: "checkout_source",
      text: "Gender",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.gender === "male" ? "♂" : row?.gender === "female" ? "♀" : ""}{" "}
            {row?.gender || "-"}
          </span>
        );
      },
    },
    {
      dataField: "goal_remarks",
      text: "Goal",
      formatter: (_, row) => {
        return (
          <span
            className={`tb-data ${row?.goal_remarks ? "tb-link" : ""}`}
            onClick={() => {
              if (row?.goal_remarks) {
                setSelectedGoalRemarks(row.goal_remarks);
                setGoalRemarksModal(true);
              }
            }}
          >
            {row?.goal_remarks ? "view" : "NA"}
          </span>
        );
      },
    },
    ...(canEditSubscription
      ? [
          {
            dataField: "actions",
            text: "Actions",
            formatter: (_, row) => {
              return (
                <div className="pp-employee-payroll-actions">
                  {/* Invoice is admin-only; gym sees Edit only */}
                  {isAdmin && (
                    <button
                      key="available-trainers"
                      type="button"
                      className={`pp-employee-payroll-action-button pp-outlined-border ${
                        !row?.invoice_link ? "disabled" : ""
                      }`}
                      onClick={() => {
                        if (row?.invoice_link) {
                          window.open(row.invoice_link, "_blank");
                        } else {
                          return;
                        }
                      }}
                      disabled={!row?.invoice_link}
                    >
                      <DownloadIcon color="#000" />
                      invoice
                    </button>
                  )}

                  <button
                    key="available-trainers"
                    type="button"
                    className="pp-employee-payroll-action-button pp-outlined-border"
                    onClick={() => {
                      setEditInfo(row);
                      setEditModal(true);
                    }}
                  >
                    <EditIcon1 color="#000" />
                    edit
                  </button>
                </div>
              );
            },
          },
        ]
      : []),
  ];

  return (
    <div className="subscriptionTbContainer" style={{ marginTop: "20px" }}>
      <Modal
        isOpen={imageModal}
        onRequestClose={() => {
          setImageModal(false);
          setViewImage("");
        }}
        contentLabel="View Image Modal"
        ariaHideApp={false}
      >
        <div
          className="createNewCTOModalContainer discussionModalBriefContainer"
          style={{
            width: "auto",
            height: "auto",
          }}
        >
          <ModalHeadAndClose
            title=" "
            onClose={() => {
              setImageModal(false);
              setViewImage("");
            }}
          />
          <div className="discussionModalMessage mt30">
            <img
              src={viewImage}
              alt="profile"
              style={{
                width: "400px",
                height: "400px",
              }}
            />
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={editModal}
        onRequestClose={() => {
          setEditModal(false);
          setEditInfo({});
        }}
        contentLabel="Subscription Edit Modal"
        ariaHideApp={false}
      >
        <div
          className="createNewCTOModalContainer discussionModalBriefContainer"
          style={{
            width: "auto",
            height: "auto",
          }}
        >
          <ModalHeadAndClose
            title="Edit Subscription Dates"
            onClose={() => {
              setEditModal(false);
              setEditInfo({});
            }}
          />
          <SubscriptionEditForm
            createSubsFormErrors={createSubsFormErrors}
            createSubsFormData={createSubsFormData}
            setCreateSubsFormData={setCreateSubsFormData}
            onClickSubmit={onClickSubmit}
          />
        </div>
      </Modal>

      <Modal
        isOpen={goalRemarksModal}
        onRequestClose={() => {
          setGoalRemarksModal(false);
          setSelectedGoalRemarks("");
        }}
        contentLabel="Goal Remarks Modal"
        ariaHideApp={false}
      >
        <div
          className="createNewCTOModalContainer"
          style={{
            maxWidth: "600px",
            width: "auto",
            height: "auto",
          }}
        >
          <ModalHeadAndClose
            title="User Goal Remarks"
            onClose={() => {
              setGoalRemarksModal(false);
              setSelectedGoalRemarks("");
            }}
          />
          <div className="discussionModalMessage mt30">
            <div className="user-details">
              <p
                style={{
                  color: "#000",
                  fontWeight: "normal",
                }}
              >
                {selectedGoalRemarks?.replace(/_/g, " ")}
              </p>
            </div>
          </div>
        </div>
      </Modal>

      <div className="common-table-container tb-bordered mt15">
        <CommonTable
          tableData={
            allSubsTbData.allSubsData?.length > 0
              ? allSubsTbData.allSubsData
              : []
          }
          tableColumns={tbColumns}
          tablePagination={
            allSubsTbData.pagination?.length > 0 ? allSubsTbData.pagination : []
          }
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={allSubscriptionDataLoading}
        />
      </div>

      {/* {allSubscriptionDataLoading ? (
        <TableSkeleton columns={9} rows={5} />
      ) : (
        <PaymentLinkTable
          tableData={
            allSubsTbData.allSubsData?.length > 0
              ? allSubsTbData.allSubsData
              : []
          }
          tableColumns={subsTbColumn}
          tablePagination={
            allSubsTbData.pagination?.length > 0 ? allSubsTbData.pagination : []
          }
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )} */}
    </div>
  );
};

export default SubscriptionTable;
